module.exports = __webpack_public_path__ + "img/ico-active.a5a77552.svg";